import Login from '@/views/common/Login'
import LoginEN from '@/views/common/LoginEN'

export default [
  {
    path: '/',
    name: 'login',
    component: Login,
    children: [
      {
        path: '/exhibition/login/ch/Phone',
        name: 'exhibition/login/ch/Phone',
        meta: {auth: false, title: "账户重置", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/Phone'], resolve)
      },
      {
        path: '/exhibition/login/ch/Mailbox',
        name: 'exhibition/login/ch/Mailbox',
        meta: {auth: false, title: "账户重置", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/Mailbox'], resolve)
      },
      {
        path: '/exhibition/login/ch/Administrator',
        name: 'exhibition/login/ch/Administrator',
        meta: {auth: false, title: "账户重置", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/Administrator'], resolve)
      },
      {
        path: '/exhibition/login/ch/Reset',
        name: 'exhibition/login/ch/Reset',
        meta: {auth: false, title: "账户重置", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/Reset'], resolve)
      },
      {
        path: '/exhibition/login/ch/ForgetPassword',
        name: 'exhibition/login/ch/ForgetPassword',
        meta: {auth: false, title: "忘记用户名", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/ForgetPassword'], resolve)
      },
      {
        path: '/exhibition/login/ch/ForgetUsername',
        name: 'exhibition/login/ch/ForgetUsername',
        meta: {auth: false, title: "忘记密码", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/ForgetUsername'], resolve)
      },
      {
        path: '/exhibition/login/ch/Register',
        name: 'exhibition/login/ch/Register',
        meta: {auth: false, title: "用户注册", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/Register'], resolve)
      },
      {
        path: '/exhibition/login/ch/Login',
        name: 'exhibition/login/ch/Login',
        meta: {auth: false, title: "用户登录", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/Login'], resolve)
      },
      {
        path: '/exhibition/login/ch/changePassword',
        name: 'exhibition/login/ch/changePassword',
        meta: {auth: false, title: "忘记密码", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/ChangePassword'], resolve)
      },
      {
        path: '/exhibition/login/ch/LoginByMessage',
        name: 'exhibition/login/ch/LoginByMessage',
        meta: {auth: false, title: "短信验证码登录", operation: true},
        component: resolve => require(['@/views/exhibition/login/ch/LoginByMessage'], resolve)
      },
    ],
    redirect:'/exhibition/login/ch/Login'
  },
  {
    path: '/',
    name: 'loginEN',
    component: LoginEN,
    children: [
      {
        path: '/exhibition/login/en/ForgetPassword',
        name: 'exhibition/login/en/ForgetPassword',
        meta: {auth: false, title: "忘记用户名", operation: true},
        component: resolve => require(['@/views/exhibition/login/en/ForgetPassword'], resolve)
      },
      {
        path: '/exhibition/login/en/ForgetUsername',
        name: 'exhibition/login/en/ForgetUsername',
        meta: {auth: false, title: "忘记密码", operation: true},
        component: resolve => require(['@/views/exhibition/login/en/ForgetUsername'], resolve)
      },
      {
        path: '/exhibition/login/en/Register',
        name: 'exhibition/login/en/Register',
        meta: {auth: false, title: "用户注册", operation: true},
        component: resolve => require(['@/views/exhibition/login/en/Register'], resolve)
      },
      {
        path: '/exhibition/login/en/Login',
        name: 'exhibition/login/en/Login',
        meta: {auth: false, title: "用户登录", operation: true},
        component: resolve => require(['@/views/exhibition/login/en/Login'], resolve)
      },
      {
        path: '/exhibition/login/en/changePassword',
        name: 'exhibition/login/en/changePassword',
        meta: {auth: false, title: "忘记密码", operation: true},
        component: resolve => require(['@/views/exhibition/login/en/ChangePassword'], resolve)
      },
    ],
    redirect:'/exhibition/login/en/Login'
  }
]


// WEBPACK FOOTER //
// ./src/router/login.js